module.exports = __webpack_public_path__ + "img/DOE-Logo@4x1_3.8cfcc4b7.svg";